import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';
import { navItems } from '../../config';

export interface NavBarItem {
    name: string;
    icon: string;
    route: string;
}

interface NavBarProp {
    items: NavBarItem[];
}

export default function NavBar({ items }: NavBarProp) {
    const location = useLocation();

    const isActive = (path: string) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
    
    if (!navItems.some((item) => isActive(item.route)))
        return null;

    return <>
        <nav>
            <ul className="d-flex">
                {items.map((item, idx) => {
                    const isActiveItem = isActive(item.route)
                    return <li key={idx} className={isActiveItem ? 'active' : ''} title={item.name}>
                        <Link to={isActiveItem ? '#' : item.route}>
                            <span className='icon'>{item.icon}</span>
                            <span className='shadow'>{item.icon}</span>
                        </Link>
                    </li>
                })}
            </ul>
        </nav>
    </>
}